module.exports = __webpack_public_path__ + "static/media/sidebar-2.a57fcf85.jpg";